import { useState } from "react";
import { MapPin, Clock } from "lucide-react";
import CTA from "../components/CTA";
export default function Careers() {
  const [selectedJob, setSelectedJob] = useState(null);

  
  const jobs = [
   
    // {
    //   title: "Delivery Rider",
    //   location: "Morocco",
    //   type: "Full-time",
    // },
    // {
    //   title: "Customer Support Agent",
    //   location: "Remote",
    //   type: "Full-time",
    // },
    // {
    //   title: "Logistics Coordinator",
    //   location: "Zanzibar",
    //   type: "Full-time",
    // },
  ];

  return (
    <div className="bg-gray-50">

      {/* HERO */}
      <div className="bg-white py-16 px-10 text-center">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-800">
          Join <span className="text-orange-500">Jopo</span>
        </h1>

        <p className="mt-4 max-w-2xl mx-auto text-gray-600">
          Be part of a fast-growing logistics platform transforming delivery across cities and beyond.
        </p>
      </div>

      {/* WHY WORK WITH US */}
      <div className="py-16 px-10 bg-white">
        <div className="grid md:grid-cols-3 gap-6 text-center">

          <div>
            <h3 className="text-lg font-semibold text-orange-500">Growth</h3>
            <p className="text-gray-600 mt-2">
              Build your career in a fast-growing tech-driven company.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-orange-500">Flexibility</h3>
            <p className="text-gray-600 mt-2">
              Work in a dynamic environment with flexible opportunities.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-orange-500">Impact</h3>
            <p className="text-gray-600 mt-2">
              Help shape the future of logistics and delivery.
            </p>
          </div>

        </div>
      </div>

      {/* JOBS SECTION */}
      <div className="py-16 px-10">

        {/* TITLE */}
        <div className="flex items-center justify-center mb-12">
          <div className="w-24 h-1 bg-orange-400"></div>

          <h2 className="mx-4 text-2xl font-bold text-gray-800">
            Open Positions
          </h2>

          <div className="w-24 h-1 bg-orange-400"></div>
        </div>

        {/* CONDITIONAL RENDERING */}
        {jobs.length > 0 ? (
          <div className="space-y-6 max-w-3xl mx-auto">
            {jobs.map((job, i) => (
              <div
                key={i}
                className="p-6 bg-white shadow-md rounded-lg flex justify-between items-center hover:shadow-lg transition"
              >

                {/* JOB INFO */}
                <div>
                  <h3 className="font-semibold text-lg text-gray-800">
                    {job.title}
                  </h3>

                  <div className="flex gap-4 text-sm text-gray-500 mt-2">
                    <span className="flex items-center gap-1">
                      <MapPin size={14} /> {job.location}
                    </span>

                    <span className="flex items-center gap-1">
                      <Clock size={14} /> {job.type}
                    </span>
                  </div>
                </div>

                {/* APPLY BUTTON */}
                <button
                  onClick={() => setSelectedJob(job)}
                  className="bg-orange-500 text-white px-4 py-2 rounded-full hover:bg-orange-600"
                >
                  Apply
                </button>

              </div>
            ))}
          </div>
        ) : (
          /* EMPTY STATE */
          <div className="text-center py-16 bg-white rounded-lg shadow-md max-w-2xl mx-auto">

            <div className="text-orange-500 text-5xl mb-4">
              
            </div>

            <h3 className="text-xl font-semibold text-gray-800">
              No Open Positions at the Moment
            </h3>

            <p className="text-gray-500 mt-2">
              We are always growing. Please check back later or send us your CV.
            </p>

            <button className="mt-6 bg-orange-500 text-white px-6 py-2 rounded-full">
              Send Resume
            </button>

          </div>
        )}
      </div>

      {/* APPLY MODAL */}
      {selectedJob && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center px-4">
          <div className="bg-white p-6 rounded-lg w-full max-w-md">

            <h3 className="text-lg font-bold mb-4">
              Apply for {selectedJob.title}
            </h3>

            <form className="space-y-4">

              <input
                type="text"
                placeholder="Full Name"
                className="w-full border p-2 rounded"
              />

              <input
                type="email"
                placeholder="Email"
                className="w-full border p-2 rounded"
              />

              <input
                type="file"
                className="w-full border p-2 rounded"
              />

              <button
                type="submit"
                className="w-full bg-orange-500 text-white py-2 rounded-full"
              >
                Submit Application
              </button>
            </form>

            <button
              onClick={() => setSelectedJob(null)}
              className="mt-4 text-gray-500 text-sm"
            >
              Close
            </button>

          </div>
        </div>
      )}

      {/* CTA */}
      <CTA/>.

    </div>
  );
}